<script setup>
import { APP_URL, CONTACT_EMAIL } from '@/lib/site';
import logo from '@/assets/img/logo-dark.svg';

const year = new Date().getFullYear();
</script>

<template>
  <footer class="footer">
    <div class="wrap inner">
      <div class="brand">
        <img :src="logo" alt="minni map" width="104" />
        <p>Sprint roadmaps that stay on your device.</p>
      </div>
      <nav class="links" aria-label="Footer">
        <a :href="APP_URL" target="_blank" rel="noopener">Open the app</a>
        <RouterLink to="/privacy-policy">Privacy Policy</RouterLink>
        <RouterLink to="/terms-of-use">Terms of Use</RouterLink>
        <a :href="`mailto:${CONTACT_EMAIL}`">Contact</a>
      </nav>
      <p class="copy">© {{ year }} Minni Map</p>
    </div>
  </footer>
</template>

<style scoped lang="scss">
.footer {
  margin-top: 96px;
  border-top: 1px solid var(--line);
}

.inner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px 40px;
  padding-top: 32px;
  padding-bottom: 40px;
}

.brand {
  img {
    display: block;
  }

  p {
    margin-top: 8px;
    font-size: 13px;
    color: var(--text-3);
  }
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  margin-left: auto;

  a {
    font-size: 13px;
    color: var(--text-2);

    &:hover {
      color: var(--text);
    }
  }
}

.copy {
  font-size: 12px;
  color: var(--text-3);
}

@media (max-width: 720px) {
  .links {
    margin-left: 0;
  }
}
</style>
